module.exports = __webpack_public_path__ + "static/img/30015 (3).6ea3f46.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30015 (3).webp
// module id = RJJ3
// module chunks = 14